import { connect, MapStateToProps } from 'react-redux';
import { getDataEntityById } from '@wix/da-shared-react/pkg/redux/entities/selectors';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { getActiveSection } from '../../selectors/studio';
import { AppState } from '../../types/store';
import { Props } from './DeviationSubmitNotification';

export type StateProps = Pick<Props, 'activeSection'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { deviation, deviationIds = [] }
) => ({
  activeSection: getActiveSection(state),
  deviation:
    deviation ||
    (deviationIds.length === 1
      ? getDataEntityById(state, deviationSchema, deviationIds[0])
      : undefined),
});

export default connect(mapStateToProps);
